import React from "react";
import "./../../css/Footer.css";

const Footer = () => {
  return (
    <div>
      <div className="container-fluid">
        <div className="container-fluid d-flex align-items-center justify-content-between py-2">
          <div className="">
            <span className="fnt12 fw-500 me-1 text-secondary">2025&copy;</span>
            <a
              href="#"
              target="_blank"
              className="footer-title fnt12 fw-400"
            >
              Neosilica
            </a>
          </div>
          <div className="d-flex align-items-center">
            <ul className="d-flex align-items-center footer-menu-item">
              <li className="menu-item">
                <a
                  href="#"
                  target="_blank"
                  className="text-secondary fnt12 fw-500 px-3"
                >
                  About
                </a>
              </li>
              <li className="menu-item">
                <a
                  href="#"
                  target="_blank"
                  className="text-secondary fnt12 fw-500 px-3"
                >
                  Support
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
